/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedDetailItemInvoice_user$ref = any;
type PdpSharedDetailPayments_user$ref = any;
type PdpSharedDetailShipping_user$ref = any;
export type PdpRespShippingReturns_user$ref = any;
export type PdpRespShippingReturns_user = {
    readonly " $fragmentRefs": PdpSharedDetailPayments_user$ref & PdpSharedDetailShipping_user$ref & PdpSharedDetailItemInvoice_user$ref;
    readonly " $refType": PdpRespShippingReturns_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailPayments_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailItemInvoice_user",
      "args": null
    }
  ]
};
(node as any).hash = '5254f0603acaa85f2ce928fe52c22f2d';
export default node;
